module.exports = __webpack_public_path__ + "img/overlay-bg.d6eed041.png";